<template>
	<div class="icon">
		<Sort v-if="isActive === null" class="icon__sort" :alt="alt" />
		<SortDown v-else-if="isActive" class="icon__sort" :alt="alt" />
		<SortUp v-else class="icon__sort" :alt="alt" />
	</div>
</template>
<script>
import Sort from './Sort.vue';
import SortUp from './SortUp.vue';
import SortDown from './SortDown.vue';
export default {
	name: 'SortUpDown',
	components: {
		Sort,
		SortUp,
		SortDown,
	},
	props: {
		isActive: {
			required: true,
		},
		alt: {
			type: String,
			required: true,
		},
	},
};
</script>
<style scoped>
.icon__sort {
	margin-left: 5px;
	width: 14px;
	height: 14px;
	cursor: pointer;
}
</style>
